import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// Firebase configuration
// Replace with your actual Firebase config
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDxUb2G7rz0AclxRwmxn2XrJe4GhVQJhok",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "prim-a7eb9.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "prim-a7eb9",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "prim-a7eb9.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "856834361026",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:856834361026:web:6796062215129a1452dd5b",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-CWMWXPKWLP"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

export default app;

